import { methods } from "../../utils/axios";

export default class TestPreviewAPI {
  // Contenido real del test unificado, sin candidato (solo superadmins).
  static get() {
    return methods.get('/tests/preview');
  }
}
